import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimType.Save.IRequest;
type Response = Api.Core.ClaimType.Save.IResponse;
type Headers = Api.Core.ClaimType.Save.IHeaders;
const url = '/api/Claims/ClaimType';
export default async function claimTypeSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
